// Path: ./src/hooks/usePromotionTags.ts
import { useState, useEffect, useCallback, useContext } from "react";
import { adminApiService } from "../utils/api";
import { GoFlyerAdminContext } from "../contextApi/context";
import { setPromotionTags } from "../contextApi/reducer";

export const usePromotionTags = () => {
  const { state, dispatch } = useContext(GoFlyerAdminContext);
  const [isPromotionTagsOptionLoading, setIsPromotionTagsOptionLoading] =
    useState(false);

  const fetchAdminPromotionTags = useCallback(async () => {
    setIsPromotionTagsOptionLoading(true);
    try {
      const result =
        await adminApiService.getManyBaseGfPromotionTagAdminControllerGfPromotionTag();

      dispatch(setPromotionTags(result.data));
    } catch (error) {
      console.error("Error fetching promotion tags:", error);
    }
    setIsPromotionTagsOptionLoading(false);
  }, [dispatch]);

  useEffect(() => {
    if (!state.promotionTags) {
      fetchAdminPromotionTags();
    }
  }, [state.promotionTags, fetchAdminPromotionTags]);

  return {
    promotionTags: state.promotionTags,
    isPromotionTagsOptionLoading,
    fetchAdminPromotionTags,
  };
};
